module.exports = __webpack_public_path__ + "static/media/banner__MP_960.96f8d499.jpg";